import { render, staticRenderFns } from "./TableConfigColumnFilterV2.vue?vue&type=template&id=11b17e33&"
import script from "./TableConfigColumnFilterV2.vue?vue&type=script&lang=js&"
export * from "./TableConfigColumnFilterV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports